import React from "react";

const theme = {
  primary: "#E8540A",
  primaryLight: "#FF6B2B",
  bg: "#FFFAF5",
  cardBg: "#FFFFFF",
  text: "#1A0A00",
  textMuted: "#5A3A20",
  border: "#F0D0B0",
  gradient: "linear-gradient(135deg, #E8540A 0%, #FF8C42 100%)",
};

const ClothingIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M16.5 6.5c0 1.5-.5 2.8-1.4 3.8L17 22H7L8.9 10.3C8 9.3 7.5 8 7.5 6.5c0-.8.1-1.6.4-2.3L5 6l2 4-3 1 1 11h14l1-11-3-1 2-4-2.9-1.8c.3.7.4 1.5.4 2.3z"/>
  </svg>
);

const IdolIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7zm2 14H10v-1h4v1zm0-3H10v-1h4v1zm-2-4.5C10.07 8.5 8.5 6.93 8.5 5h1c0 1.38 1.12 2.5 2.5 2.5S14.5 6.38 14.5 5h1c0 1.93-1.57 3.5-3.5 3.5z"/>
  </svg>
);

const HerbIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 008 20C19 20 22 3 22 3c-1 2-8 2-8 2 2-2 8-2 8-2-3 5-8 7-8 7s-3.5-1.5-5 0 0 5 0 5z"/>
  </svg>
);

const BasketIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="26" height="26">
    <path d="M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L22 10c0-.55-.45-1-1-1h-3.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="rgba(255,255,255,0.2)" width="80" height="80">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
  </svg>
);

const categories = [
  {
    icon: <ClothingIcon />,
    iconBg: "rgba(255,255,255,0.2)",
    headerBg: "linear-gradient(135deg, #D04000, #E8540A)",
    title: "वस्त्र व पूजोपयोगी साहित्य",
    subtitle: "Clothing & Worship Materials",
    items: ["धोती, दुपट्टा", "ध्वज, अष्टमंगल", "कलश (सर्व प्रकार)", "नंदा दीप, घंटा", "अभिषेक वाद्य यंत्र"],
  },
  {
    icon: <IdolIcon />,
    iconBg: "rgba(255,255,255,0.2)",
    headerBg: "linear-gradient(135deg, #E8680A, #FF9830)",
    title: "प्रतिमा व पूजासाहित्य",
    subtitle: "Idols & Worship Items",
    items: ["पितळी लहान-मोठ्या प्रतिमा", "संगमरवरी मूर्ती", "मानस्तंभ मूर्ती", "मूलनायक भगवान प्रतिमा", "शिखरावरील कलश व पितळी ध्वज", "अष्टप्रातीहार्य"],
  },
  {
    icon: <HerbIcon />,
    iconBg: "rgba(255,255,255,0.2)",
    headerBg: "linear-gradient(135deg, #F07A10, #FFB040)",
    title: "द्रव्य व औषधी साहित्य",
    subtitle: "Ritual Materials & Herbs",
    items: ["अष्टगंध, केशर", "सात प्रकारच्या सर्वोषधी", "कलकचूर्ण", "होम सिमधा", "धूप, उद, भिमसेन कापूर", "पिवळी मोहरी, पांडुकशिला"],
  },
  {
    icon: <BasketIcon />,
    iconBg: "rgba(255,255,255,0.2)",
    headerBg: "linear-gradient(135deg, #D04000, #E8540A)",
    title: "विशेष पूजासाहित्य",
    subtitle: "Special Worship Items",
    items: ["समवशरण", "अभिषेक पीठ व अभिषेक पात्र", "चातुर्मास कलश", "सर्व प्रकारचे कलश", "पूजा थाळी सेट"],
  },
];

const badges = ["100% प्रामाणिक", "शुद्ध सामग्री", "शास्त्रशुद्ध"];

export default function PoojaPage() {
  return (
    <div style={{
      minHeight: "100vh",
      backgroundColor: theme.bg,
      fontFamily: "'Noto Sans Devanagari', 'Segoe UI', sans-serif",
      color: theme.text,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700;800&family=Noto+Serif+Devanagari:wght@400;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        .page-header {
          text-align: center;
          padding: 72px 24px 52px;
          max-width: 800px;
          margin: 0 auto;
          position: relative;
        }

        .om-bg {
          position: absolute;
          right: 20px; top: 50px;
          font-size: 120px;
          color: rgba(232,84,10,0.07);
          font-family: 'Noto Serif Devanagari', serif;
          pointer-events: none; user-select: none; line-height: 1;
        }

        .eyebrow {
          font-size: 18px; letter-spacing: 3px; color: ${theme.primary};
          font-weight: 600; margin-bottom: 14px; text-transform: uppercase;
        }

        .hero-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: clamp(34px, 5.5vw, 58px);
          font-weight: 700; color: ${theme.text};
          margin-bottom: 16px; line-height: 1.2;
        }

        .title-divider {
          width: 56px; height: 3px; background: ${theme.primary};
          margin: 0 auto 24px; border-radius: 2px;
        }

        .subtitle {
          font-size: 16px; color: ${theme.textMuted}; line-height: 1.7;
        }

        .grid-wrap {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 24px 64px;
        }

        .grid-container {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }

        .sahitya-card {
          background: #fff;
          border: 1.5px solid ${theme.border};
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.28s ease;
          cursor: default;
          text-align: center; /* कार्डमधील संपूर्ण टेक्स्ट सेंटरला */
        }

        .sahitya-card:hover {
          border-color: ${theme.primary};
          box-shadow: 0 8px 32px rgba(232,84,10,0.12);
          transform: translateY(-4px);
        }

        .card-header {
          padding: 20px 24px; 
          display: flex; 
          flex-direction: column; /* हेडर आयटम्स उभे करण्यासाठी */
          align-items: center; 
          gap: 12px;
          text-align: center;
        }

        .header-icon {
          width: 46px; height: 46px; border-radius: 10px;
          background: rgba(255,255,255,0.22);
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }

        .header-text .card-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 17px; font-weight: 700; color: #fff;
          margin-bottom: 2px; line-height: 1.3;
        }

        .header-text .card-subtitle {
          font-size: 12.5px; color: rgba(255,255,255,0.82); font-style: italic;
        }

        .card-body { padding: 24px; }
        .card-list { list-style: none; padding: 0; }
        
        .card-list li {
          font-size: 14.5px; 
          color: ${theme.textMuted};
          padding: 6px 0;
          line-height: 1.5;
          display: flex;
          align-items: center;
          justify-content: center; /* लिस्ट आयटम्स सेंटरला */
          gap: 8px; /* बुलेट आणि टेक्स्ट मधील अंतर */
        }

        /* बुलेट्स सेंटरला घेण्यासाठी खास स्टाइल */
        .card-list li::before {
          content: '•'; 
          color: ${theme.primary};
          font-size: 18px;
          font-weight: bold;
        }

        .quality-wrap { max-width: 1100px; margin: 0 auto 80px; padding: 0 24px; }
        .quality-banner {
          background: ${theme.gradient}; border-radius: 18px;
          padding: 48px 48px; text-align: center; position: relative; overflow: hidden;
        }
        .quality-check-bg { position: absolute; right: 40px; top: 50%; transform: translateY(-50%); pointer-events: none; }
        .quality-title { font-family: 'Noto Serif Devanagari', serif; font-size: 26px; font-weight: 700; color: #fff; margin-bottom: 14px; }
        .quality-sub { font-size: 15px; color: rgba(255,255,255,0.92); line-height: 1.8; max-width: 680px; margin: 0 auto 24px; }
        .badge-row { display: flex; justify-content: center; gap: 12px; flex-wrap: wrap; }
        .quality-badge { border: 1.5px solid rgba(255,255,255,0.7); border-radius: 30px; padding: 8px 22px; font-size: 14px; color: #fff; font-weight: 600; background: rgba(255,255,255,0.1); }

        @media (max-width: 1100px) { .grid-container { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 600px) { .grid-container { grid-template-columns: 1fr; } }
      `}</style>

      <div className="page-header">
        <div className="om-bg">🪷</div>
        <p className="eyebrow">पू जा  सा हि त्या</p>
        <h1 className="hero-title">शुद्ध व दर्जेदार साहित्य</h1>
        <div className="title-divider" />
        <p className="subtitle">दिगंबर जैन पूजेसाठी लागणारे खात्रीशीर, शुद्ध व दर्जेदार साहित्य</p>
      </div>

      <div className="grid-wrap">
        <div className="grid-container">
          {categories.map((cat, i) => (
            <div key={i} className="sahitya-card">
              <div className="card-header" style={{ background: cat.headerBg }}>
                <div className="header-icon">{cat.icon}</div>
                <div className="header-text">
                  <p className="card-title">{cat.title}</p>
                  <p className="card-subtitle">{cat.subtitle}</p>
                </div>
              </div>
              <div className="card-body">
                <ul className="card-list">
                  {cat.items.map((item, j) => <li key={j}>{item}</li>)}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="quality-wrap">
        <div className="quality-banner">
          <div className="quality-check-bg"><CheckIcon /></div>
          <p className="quality-title">गुणवत्ता व शुद्धतेची खात्री</p>
          <p className="quality-sub">आमच्याकडून मिळणारे सर्व पूजासाहित्य गुणवत्ता, शुद्धता व विश्वासाहीतेची पूर्ण खात्री देते.</p>
          <div className="badge-row">
            {badges.map((b, i) => <span key={i} className="quality-badge">{b}</span>)}
          </div>
        </div>
      </div>
    </div>
  );
}